import Dialog from "@mui/material/Dialog";
import { ReactNode } from "react";
import "./ContentModal.modules.scss"

export interface ContentModalProps {
  open: boolean;
  onClose: () => void;
  content?: ReactNode;
}

export default function ContentModal({
  onClose,
  open,
  content,
}: ContentModalProps) {
  return (
    <Dialog onClose={onClose} open={open}>
      {content}
    </Dialog>
  );
}
